"use client";
import styled, { css } from "styled-components";
import { PageWrapper, screens } from "./globalsStyles";

export const RegisterPageWrapper = styled(PageWrapper)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  ${screens({
    mobile: css`
      flex-direction: column;
      padding-bottom: 2rem;
    `,
    desktop: css`
      /* flex-direction: row; */
    `
  })}
`;
